import {styled} from '@esgi/ui/theme';
import {GridBox} from '@esgi/ui/layout';

export const StyledScrollBody = styled(GridBox, {
	gap: '$2',
	alignContent: 'start',
	paddingBottom: 60,
	overflowY: 'scroll',
});